import { ExchangeReportProfilePermissions, ExchangeReportProfileDelegate } from '@i2a/web-api-client';

export class ExchangeDelegate {
    permissions: ExchangeReportProfilePermissions;
    accesses: ExchangeReportProfileDelegate;
}
